import { render } from "./TheSidebarUserPanel.vue?vue&type=template&id=05cc886f"
import script from "./TheSidebarUserPanel.vue?vue&type=script&lang=js"
export * from "./TheSidebarUserPanel.vue?vue&type=script&lang=js"

import exportComponent from "/Users/datis/Developer/ad-impact/web-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__